import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=ffa7c6ca&scoped=true&lang=html"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"
import style0 from "./Credits.vue?vue&type=style&index=0&id=ffa7c6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa7c6ca",
  null
  
)

export default component.exports